import React, { useEffect } from "react";
import { useAppDispatch } from "../../hooks/useAuth";
import { initializeAuth } from "../../services/auth/authSlice";

const AuthInitializer = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  return <>{children}</>;
};

export default AuthInitializer;
